import { MonitoringScreen } from '../containers/Monitoring';
import { accessTypeEnum } from '../lib/enum';

export default [
{
  component: MonitoringScreen,
  path: '/monitoring',
  access: [accessTypeEnum.admin, accessTypeEnum.adminBranch]
}];
